"use client";

import { c as _c } from "react/compiler-runtime";
import type { ExperienceConfiguration } from "@ninetailed/experience.js-react";
import { PersonalizedEntry } from "@/app/_components/PersonalizedEntry";
import type { CardSectionVariantData } from "@/lib/ninetailed/mapCardSectionExperiences";
import { CardRowView } from "./CardRowView";
interface Props {
  baseline: CardSectionVariantData;
  experiences: ExperienceConfiguration<CardSectionVariantData>[];
  exposures: Record<string, number>;
}
export function PersonalizedCardRow(t0) {
  const $ = _c(4);
  const {
    baseline,
    experiences,
    exposures
  } = t0;
  let t1;
  if ($[0] !== baseline || $[1] !== experiences || $[2] !== exposures) {
    t1 = <PersonalizedEntry baseline={baseline} experiences={experiences} exposures={exposures} view={CardRowView} />;
    $[0] = baseline;
    $[1] = experiences;
    $[2] = exposures;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}